import { render } from "./BattleView.vue?vue&type=template&id=47bbf8da"
import script from "./BattleView.vue?vue&type=script&lang=js"
export * from "./BattleView.vue?vue&type=script&lang=js"

import "./BattleView.vue?vue&type=style&index=0&id=47bbf8da&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__